/*
 * Copyright (C) 2013 Minted Inc.
 *
 * All Rights Reserved
 */

(function (M, _, $, Backbone) {
  "use strict";

  M.Collection = M.Collection || {};
  M.Collection.Design = M.Collection.Design || {};

  /**
   * @class M.Collection.Design.PollOption
   *
   */
  M.Collection.Design.PollOption = Backbone.Collection.extend({
    model: M.Model.Design.PollOption,

    initialize: function() {
      var models = [];
      this.each(function (model) {
        models.push(new M.Model.Design.PollOption(model));
      });
      this.reset(models);
    }
  });

})(M, _, $, Backbone);
